module.exports = __webpack_public_path__ + "addeparStep2InvestmentName.4973fe605c22b9c108481228eeb500c2.png";